import constants from './constants'

const getAvatar = avatarInfo => {
  const PURPLE_HEX = 'F0E6FF'
  const GRAY_HEX = '4A4A4A'

  return `${constants.UI_AVATARS_ENDPOINT}?background=${PURPLE_HEX}&color=${GRAY_HEX}&name=${avatarInfo}`
}

export { getAvatar }
